__turbopack_context__.v({
  "app_light_theme": "AddToComparison-module-scss-module__uXAgya__app_light_theme",
  "inComparison": "AddToComparison-module-scss-module__uXAgya__inComparison",
  "inComparisonPage": "AddToComparison-module-scss-module__uXAgya__inComparisonPage",
  "root": "AddToComparison-module-scss-module__uXAgya__root",
});
